import { createFileRoute } from '@tanstack/react-router'
import { ProductDetailPage } from '@/pages/product-detail'

export const Route = createFileRoute('/_authenticated/products/$productId')({
  staticData: { title: 'Product' },
  component: ProductDetailRoute,
})

function ProductDetailRoute() {
  const { productId } = Route.useParams()
  return <ProductDetailPage productId={productId} />
}
